module.exports = __webpack_public_path__ + "img/contact-banner.defc9fd6.jpg";